

import React, { Component } from 'react';
import PreLoaderWidget from './Loader';

class LoadingFullScreen extends Component {

    render() {
        return (
            <div className="card" style={{ width: "100%", height: "100%", opacity: 0.8, margin: "0 auto", position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99 }}>
                <div className="card-body">
                    <div className="text-center" style={{
                        textAlign: 'center', top: '50%',
                        position: 'absolute',
                        left: '50%'
                    }}><center>
                            <PreLoaderWidget ></PreLoaderWidget>
                            carregando...
                        </center>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoadingFullScreen;